function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _excluded = ["widget", "placeholder", "autofocus", "autocomplete", "title"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import omit from 'lodash/omit';
import { ANY_OF_KEY, deepEquals, ERRORS_KEY, getDiscriminatorFieldFromSchema, getUiOptions, getWidget, mergeSchemas, ONE_OF_KEY, TranslatableString } from '@rjsf/utils';
/** The `AnyOfField` component is used to render a field in the schema that is an `anyOf`, `allOf` or `oneOf`. It tracks
 * the currently selected option and cleans up any irrelevant data in `formData`.
 *
 * @param props - The `FieldProps` for this template
 */

var AnyOfField = /*#__PURE__*/function (_Component) {
  _inherits(AnyOfField, _Component);

  var _super = _createSuper(AnyOfField);

  /** Constructs an `AnyOfField` with the given `props` to initialize the initially selected option in state
   *
   * @param props - The `FieldProps` for this template
   */
  function AnyOfField(props) {
    var _this;

    _classCallCheck(this, AnyOfField);

    _this = _super.call(this, props);
    /** Callback handler to remember what the currently selected option is. In addition to that the `formData` is updated
     * to remove properties that are not part of the newly selected option schema, and then the updated data is passed to
     * the `onChange` handler.
     *
     * @param option - The new option value being selected
     */

    _this.onOptionChange = function (option) {
      var _this$state = _this.state,
          selectedOption = _this$state.selectedOption,
          retrievedOptions = _this$state.retrievedOptions;
      var _this$props = _this.props,
          formData = _this$props.formData,
          onChange = _this$props.onChange,
          registry = _this$props.registry;
      var schemaUtils = registry.schemaUtils;
      var intOption = option !== undefined ? parseInt(option, 10) : -1;

      if (intOption === selectedOption) {
        return;
      }

      var newOption = intOption >= 0 ? retrievedOptions[intOption] : undefined;
      var oldOption = selectedOption >= 0 ? retrievedOptions[selectedOption] : undefined;
      var newFormData = schemaUtils.sanitizeDataForNewSchema(newOption, oldOption, formData);

      if (newOption) {
        // Call getDefaultFormState to make sure defaults are populated on change. Pass "excludeObjectChildren"
        // so that only the root objects themselves are created without adding undefined children properties
        newFormData = schemaUtils.getDefaultFormState(newOption, newFormData, 'excludeObjectChildren');
      }

      _this.setState({
        selectedOption: intOption
      }, function () {
        onChange(newFormData, undefined, _this.getFieldId());
      });
    };

    var _this$props2 = _this.props,
        formData = _this$props2.formData,
        options = _this$props2.options,
        schemaUtils = _this$props2.registry.schemaUtils; // cache the retrieved options in state in case they have $refs to save doing it later

    var retrievedOptions = options.map(function (opt) {
      return schemaUtils.retrieveSchema(opt, formData);
    });
    _this.state = {
      retrievedOptions: retrievedOptions,
      selectedOption: _this.getMatchingOption(0, formData, retrievedOptions)
    };
    return _this;
  }
  /** React lifecycle method that is called when the props and/or state for this component is updated. It recomputes the
   * currently selected option based on the overall `formData`
   *
   * @param prevProps - The previous `FieldProps` for this template
   * @param prevState - The previous `AnyOfFieldState` for this template
   */


  _createClass(AnyOfField, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props3 = this.props,
          formData = _this$props3.formData,
          options = _this$props3.options,
          idSchema = _this$props3.idSchema;
      var selectedOption = this.state.selectedOption;
      var newState = this.state;

      if (!deepEquals(prevProps.options, options)) {
        var schemaUtils = this.props.registry.schemaUtils; // re-cache the retrieved options in state in case they have $refs to save doing it later

        var retrievedOptions = options.map(function (opt) {
          return schemaUtils.retrieveSchema(opt, formData);
        });
        newState = {
          selectedOption: selectedOption,
          retrievedOptions: retrievedOptions
        };
      }

      if (!deepEquals(formData, prevProps.formData) && idSchema.$id === prevProps.idSchema.$id) {
        var _newState = newState,
            _retrievedOptions = _newState.retrievedOptions;
        var matchingOption = this.getMatchingOption(selectedOption, formData, _retrievedOptions);

        if (prevState && matchingOption !== selectedOption) {
          newState = {
            selectedOption: matchingOption,
            retrievedOptions: _retrievedOptions
          };
        }
      }

      if (newState !== this.state) {
        this.setState(newState);
      }
    }
    /** Determines the best matching option for the given `formData` and `options`.
     *
     * @param formData - The new formData
     * @param options - The list of options to choose from
     * @return - The index of the `option` that best matches the `formData`
     */

  }, {
    key: "getMatchingOption",
    value: function getMatchingOption(selectedOption, formData, options) {
      var _this$props4 = this.props,
          schema = _this$props4.schema,
          schemaUtils = _this$props4.registry.schemaUtils;
      var discriminator = getDiscriminatorFieldFromSchema(schema);
      var option = schemaUtils.getClosestMatchingOption(formData, options, selectedOption, discriminator);
      return option;
    }
  }, {
    key: "getFieldId",
    value: function getFieldId() {
      var _this$props5 = this.props,
          idSchema = _this$props5.idSchema,
          schema = _this$props5.schema;
      return "".concat(idSchema.$id).concat(schema.oneOf ? '__oneof_select' : '__anyof_select');
    }
    /** Renders the `AnyOfField` selector along with a `SchemaField` for the value of the `formData`
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          name = _this$props6.name,
          _this$props6$disabled = _this$props6.disabled,
          disabled = _this$props6$disabled === void 0 ? false : _this$props6$disabled,
          _this$props6$errorSch = _this$props6.errorSchema,
          errorSchema = _this$props6$errorSch === void 0 ? {} : _this$props6$errorSch,
          formContext = _this$props6.formContext,
          onBlur = _this$props6.onBlur,
          onFocus = _this$props6.onFocus,
          registry = _this$props6.registry,
          schema = _this$props6.schema,
          uiSchema = _this$props6.uiSchema;
      var widgets = registry.widgets,
          fields = registry.fields,
          translateString = registry.translateString,
          globalUiOptions = registry.globalUiOptions,
          schemaUtils = registry.schemaUtils;
      var _SchemaField = fields.SchemaField;
      var _this$state2 = this.state,
          selectedOption = _this$state2.selectedOption,
          retrievedOptions = _this$state2.retrievedOptions;

      var _getUiOptions = getUiOptions(uiSchema, globalUiOptions),
          _getUiOptions$widget = _getUiOptions.widget,
          widget = _getUiOptions$widget === void 0 ? 'select' : _getUiOptions$widget,
          placeholder = _getUiOptions.placeholder,
          autofocus = _getUiOptions.autofocus,
          autocomplete = _getUiOptions.autocomplete,
          _getUiOptions$title = _getUiOptions.title,
          title = _getUiOptions$title === void 0 ? schema.title : _getUiOptions$title,
          uiOptions = _objectWithoutProperties(_getUiOptions, _excluded);

      var Widget = getWidget({
        type: 'number'
      }, widget, widgets);
      var rawErrors = get(errorSchema, ERRORS_KEY, []);
      var fieldErrorSchema = omit(errorSchema, [ERRORS_KEY]);
      var displayLabel = schemaUtils.getDisplayLabel(schema, uiSchema, globalUiOptions);
      var option = selectedOption >= 0 ? retrievedOptions[selectedOption] || null : null;
      var optionSchema;

      if (option) {
        // merge top level required field
        var required = schema.required; // Merge in all the non-oneOf/anyOf properties and also skip the special ADDITIONAL_PROPERTY_FLAG property

        optionSchema = required ? mergeSchemas({
          required: required
        }, option) : option;
      } // First we will check to see if there is an anyOf/oneOf override for the UI schema


      var optionsUiSchema = [];

      if (ONE_OF_KEY in schema && uiSchema && ONE_OF_KEY in uiSchema) {
        if (Array.isArray(uiSchema[ONE_OF_KEY])) {
          optionsUiSchema = uiSchema[ONE_OF_KEY];
        } else {
          console.warn("uiSchema.oneOf is not an array for \"".concat(title || name, "\""));
        }
      } else if (ANY_OF_KEY in schema && uiSchema && ANY_OF_KEY in uiSchema) {
        if (Array.isArray(uiSchema[ANY_OF_KEY])) {
          optionsUiSchema = uiSchema[ANY_OF_KEY];
        } else {
          console.warn("uiSchema.anyOf is not an array for \"".concat(title || name, "\""));
        }
      } // Then we pick the one that matches the selected option index, if one exists otherwise default to the main uiSchema


      var optionUiSchema = uiSchema;

      if (selectedOption >= 0 && optionsUiSchema.length > selectedOption) {
        optionUiSchema = optionsUiSchema[selectedOption];
      }

      var translateEnum = title ? TranslatableString.TitleOptionPrefix : TranslatableString.OptionPrefix;
      var translateParams = title ? [title] : [];
      var enumOptions = retrievedOptions.map(function (opt, index) {
        // Also see if there is an override title in the uiSchema for each option, otherwise use the title from the option
        var _getUiOptions2 = getUiOptions(optionsUiSchema[index]),
            _getUiOptions2$title = _getUiOptions2.title,
            uiTitle = _getUiOptions2$title === void 0 ? opt.title : _getUiOptions2$title;

        return {
          label: uiTitle || translateString(translateEnum, translateParams.concat(String(index + 1))),
          value: index
        };
      });
      return _jsxs("div", {
        className: 'panel panel-default panel-body',
        children: [_jsx("div", {
          className: 'form-group',
          children: _jsx(Widget, {
            id: this.getFieldId(),
            name: "".concat(name).concat(schema.oneOf ? '__oneof_select' : '__anyof_select'),
            schema: {
              type: 'number',
              default: 0
            },
            onChange: this.onOptionChange,
            onBlur: onBlur,
            onFocus: onFocus,
            disabled: disabled || isEmpty(enumOptions),
            multiple: false,
            rawErrors: rawErrors,
            errorSchema: fieldErrorSchema,
            value: selectedOption >= 0 ? selectedOption : undefined,
            options: _objectSpread({
              enumOptions: enumOptions
            }, uiOptions),
            registry: registry,
            formContext: formContext,
            placeholder: placeholder,
            autocomplete: autocomplete,
            autofocus: autofocus,
            label: title !== null && title !== void 0 ? title : name,
            hideLabel: !displayLabel
          })
        }), optionSchema && _jsx(_SchemaField, _objectSpread(_objectSpread({}, this.props), {}, {
          schema: optionSchema,
          uiSchema: optionUiSchema
        }))]
      });
    }
  }]);

  return AnyOfField;
}(Component);

export default AnyOfField;